export default "__VITE_ASSET__Jy1Y8B9w__"